import { render, staticRenderFns } from "./StockCalcSubmissionsDetail.vue?vue&type=template&id=578b2ba6&scoped=true"
import script from "./StockCalcSubmissionsDetail.vue?vue&type=script&lang=js"
export * from "./StockCalcSubmissionsDetail.vue?vue&type=script&lang=js"
import style0 from "./StockCalcSubmissionsDetail.vue?vue&type=style&index=0&id=578b2ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578b2ba6",
  null
  
)

export default component.exports